import _ from 'lodash';
import {Module, Component} from '../decorators';


@Module({
    name: "app.orders.compontents.mimetype.icon",
})
@Component({
    selector: 'blnd-mimetype-icon',
    template: '<i class="fa {{ $ctrl.icon }}" aria-hidden="true"></i>',
    bindings: {
        ngModel: '=',
    },
})
export default class C {

    IconMapping = {
        // Images
        'image': 'fa-file-image-o',
        // Audio
        'audio': 'fa-file-audio-o',
        // Video
        'video': 'fa-file-video-o',
        // Documents
        'application/pdf': 'fa-file-pdf-o',
        'text/plain': 'fa-file-text-o',
        'text/html': 'fa-file-code-o',
        'application/json': 'fa-file-code-o',
        // Archives
        'application/gzip': 'fa-file-archive-o',
        'application/zip': 'fa-file-archive-o',
        // Misc
        'application/octet-stream': 'fa-file-o',
    };

    constructor () {
        this.icon = this.getIcon(this.ngModel);
    }

    getIcon (mimetype) {
        if (this.IconMapping[mimetype]) {
            return this.IconMapping[mimetype];
        }

        let [group, ...rest] = mimetype.split('/');
        if (this.IconMapping[group]) {
            return this.IconMapping[group];
        }

        return 'fa-file-o';
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/mimetype.icon.js